module.exports = __webpack_public_path__ + "static/taylor-5a9e644ab9362eaf14a4399f6b33be27.png";